import { database, firebase, dbFirestore } from "../../firebase";
import { v4 as uuid } from "uuid";

interface User {
  role?: string;
  deviceId: string | null;
  deviceIdUpdatedAt: number;
}

export const assignDeviceId = async (
  deviceId: string,
  userId: string
): Promise<void> => {
  await dbFirestore.collection("users").doc(userId).set(
    {
      deviceId,
      deviceIdUpdatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    },
    { merge: true }
  );
};

export const unassingDeviceId = async (userId: string): Promise<void> => {
  await dbFirestore.collection("users").doc(userId).set(
    {
      deviceId: null,
      deviceIdUpdatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    },
    { merge: true }
  );
};

export const disableSecurity = async (
  userId: string,
  finishDate: Date
): Promise<void> => {
  await dbFirestore.collection("configs").doc(userId).set(
    {
      disableSecurity: true,
      finishDate: finishDate.getTime(),
    },
    { merge: true }
  );
}; 

export const getConfigsByUserId = (
  userId: string,
  onUpdate: (data: {disableSecurity: boolean; finishDate: Date} | null) => void
): (() => void) => {
  let unsubscribe = dbFirestore
    .collection("configs")
    .doc(userId)
    .onSnapshot((userSnapshot) => {
      if (userSnapshot.exists === false) onUpdate(null);
      else {
        const data = userSnapshot.data();
        if (data !== undefined)
          onUpdate({
            disableSecurity: data.disableSecurity,
            finishDate: new Date(data.finishDate)
          });
      }
    });
  return () => unsubscribe();
};

export const getUserById = (
  userId: string,
  onUpdate: (data: User | null) => void
): (() => void) => {
  let unsubscribe = dbFirestore
    .collection("users")
    .doc(userId)
    .onSnapshot((userSnapshot) => {
      if (userSnapshot.exists === false) onUpdate(null);
      else {
        const data = userSnapshot.data();
        if (data !== undefined)
          onUpdate({
            role: data.role,
            deviceId: data.deviceId,
            deviceIdUpdatedAt: data.deviceIdUpdatedAt !== null ? (
              data.deviceIdUpdatedAt.toDate() as Date
            ).getTime() : new Date().getTime() ,
          });
      }
    });
  return () => unsubscribe();
};
